import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Chain } from "@/models/Contract";
import { ref } from "vue";
import { Protocol } from "@/models/Protocol";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  multiple: Boolean,
  required: Boolean,
  protocol: Protocol,
  selectedChain: String,
},
  emits: ["selected"],
  setup(__props, { emit }) {

const props = __props


// eslint-disable-next-line no-undef


const selected = ref<Chain[]>([]);
const label = "Chains";
const messages = props.required ? "Required" : "";
let initialChains: Chain[] = ["avalanche", "eth"];
if (props.protocol) {
  // eslint-disable-next-line vue/no-setup-props-destructure
  initialChains = props.protocol.chains;
}
const chains = ref<Chain[]>(initialChains);
const select = (chains: Chain) => {
  emit("selected", selected.value);
};

return (_ctx: any,_cache: any) => {
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createBlock(_component_va_select, {
    options: chains.value,
    label: label,
    modelValue: selected.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
      select
    ],
    multiple: "",
    messages: _unref(messages),
    success: selected.value.length > 0
  }, null, 8, ["options", "modelValue", "messages", "success"]))
}
}

})